import { useField } from 'react-final-form';

import {
  LabelChipV2,
  MetadataChipV2,
  Radio,
  Typography,
  Stack,
} from '@cast/design-system';

import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { PolicyInputProps } from '../PolicyInput';

import {
  DurationPresetInput,
  MINUTE_SECOND_PRESETS,
  RffRadioGroup,
  useControlsGroupState,
} from '@cast/shared-rff-ui';
import { PolicyCardForm } from './_components/PolicyCardForm';
import { StartupMetricsFormModel } from '../../../_types';
type StartupMetricsFieldProps = Pick<PolicyInputProps, 'LabelComponent'>;

export const StartupMetricsField = ({
  LabelComponent,
}: StartupMetricsFieldProps) => {
  const { name: typeFieldName = '' } = useControlsGroupState({ name: 'type' });
  const field = useField<StartupMetricsFormModel['type']>(typeFieldName);
  const selectedType = field.input.value;
  const showPeriodPicker =
    selectedType === 'ignore-startup' || selectedType === 'two-phase';

  return (
    <Stack gap={18} data-testid="startup-metrics-field">
      <RffRadioGroup name="type">
        <Stack gap={8}>
          <Typography variant="A1">Select strategy:</Typography>
          <PolicyCardForm
            control={
              <Radio testId="no-strategy" value="no-strategy" size="small" />
            }
            label={vpaSettingsConstants.startupMetrics.noneLabel}
            description={vpaSettingsConstants.startupMetrics.noneDescription}
          />
          <PolicyCardForm
            control={
              <Radio testId="two-phase" value="two-phase" size="small" />
            }
            label={vpaSettingsConstants.startupMetrics.twoPhaseLabel}
            description={
              vpaSettingsConstants.startupMetrics.twoPhaseDescription
            }
            badge={
              <LabelChipV2
                label="Recommended"
                color="blue"
                size="xs"
                testId="two-phase-recommended-badge"
              />
            }
          />
          <PolicyCardForm
            control={
              <Radio
                testId="ignore-startup"
                value="ignore-startup"
                size="small"
              />
            }
            label={vpaSettingsConstants.startupMetrics.ignoreLabel}
            description={vpaSettingsConstants.startupMetrics.ignoreDescription}
            badge={
              <MetadataChipV2
                label="Legacy"
                size="xs"
                variant="strong"
                testId="ignore-startup-legacy-badge"
              />
            }
          />
        </Stack>
      </RffRadioGroup>

      {showPeriodPicker && (
        <Stack gap={8}>
          <Typography variant="A1">Select time period:</Typography>
          <DurationPresetInput
            units={[
              { key: 'minutes', formAccessor: 'min' },
              { key: 'seconds', formAccessor: 'sec' },
            ]}
            presets={MINUTE_SECOND_PRESETS}
            LabelComponent={LabelComponent}
          />
        </Stack>
      )}
    </Stack>
  );
};
